import React from 'react'
import moment from 'moment'

import { Call, Information, ShieldTick, Sms } from 'iconsax-react'

import Tooltip from '../../../../atoms/Tooltip'
import PhoneFlag from '../../../../atoms/PhoneFlag'

import { getFormatted } from '../../../../../utilities/phoneNumber'
import useStyles from './styles'

const EMAIL_CHANNELS = ['email']
const PHONE_CHANNELS = ['sms_voice', 'voice_only']

const Channel = ({ user, isEmail = false, hideAlert = false }) => {
  const classes = useStyles()

  const channels = (user.channels ?? [])
    .filter(ch => (isEmail ? EMAIL_CHANNELS : PHONE_CHANNELS).includes(ch.type))
    .sort((a, b) => {
      const aDate = moment(a.created_at)
      const bDate = moment(b.created_at)
      return aDate - bDate
    })

  if (channels.length === 0) {
    return null
  }

  const [first, ...rest] = channels

  const restChannels = (
    <div className={classes.tooltip}>
      {rest.map(channel => {
        const val = channel.value
        const value = isEmail ? val : getFormatted(val)
        const Icon = isEmail ? Sms : Call

        return (
          <div key={channel.id} className='row'>
            <Icon className='icon' />{' '}
            {!isEmail && (
              <PhoneFlag value={val} style={{ marginRight: '5px' }} />
            )}
            {value}
          </div>
        )
      })}
    </div>
  )

  const dataElem = (
    <>
      {!isEmail && (
        <PhoneFlag value={first.value} style={{ marginRight: '5px' }} />
      )}
      {isEmail ? first.value : getFormatted(first.value)}
      {first.validated && <ShieldTick variant='Bold' className='shield' />}
      {!first.compliance && !hideAlert && (
        <Tooltip title='User opted out from using this channel' arrow>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Information variant='Bold' className='alert' />
          </div>
        </Tooltip>
      )}
    </>
  )

  if (rest.length > 0) {
    return (
      <Tooltip title={restChannels} className={classes.root} arrow>
        <div>
          {dataElem}
          <span className={classes.more}>+{rest.length}</span>
        </div>
      </Tooltip>
    )
  }

  return <div className={classes.root}>{dataElem}</div>
}

export default Channel
